module.exports = __webpack_public_path__ + "img/brushes-en-3.55c6b6c.jpg";